import { AuthActionType } from "components/Auth/constants";
import { USER_PROP } from "components/User/constants";

export const getDefaultState = () => ({
  loggedIn: false,
  role: "",
  register: {
    [USER_PROP.EMAIL]: "",
    [USER_PROP.FNAME]: "",
    [USER_PROP.LNAME]: "",
    [USER_PROP.PASSWORD]: "",
    [USER_PROP.ROLE]: "",
    inviteType: "",
  },
});

export default (state = getDefaultState(), action) => {
  switch (action.type) {
    case AuthActionType.SET_AUTH:
      return setAuth(state, action);
    case AuthActionType.SET_ROLE:
      return setRole(state, action);
    case AuthActionType.SET_REGISTRATION:
      return setRegistration(state, action);
    case AuthActionType.SET_INVITE_DATA:
      return {
        ...state,
        register: {
          ...state.register,
          role: action.data.role,
          email: action.data.email || "",
          inviteType: action.data.type,
        },
      };
    default:
      return state;
  }
};

const setAuth = (state, { loggedIn }) => {
  return {
    ...state,
    loggedIn,
  };
};

const setRole = (state, { role }) => {
  return {
    ...state,
    role,
  };
};

const setRegistration = (state, { register }) => {
  return {
    ...state,
    register,
  };
};
